import React from "react";
import {useTranslation} from "react-i18next";
import "./index.less";

export default function Footer() {
    const { t } = useTranslation();

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-main">
                <div className="footer-container">
                    <div className="footer-grid">
                        <div className="footer-brand">
                            <div className="brand-logo">
                                <img src="http://47.115.148.248:9000/officeweb/office_logo.png" alt="Yunchi Machinery"/>
                                <div className="brand-text">
                                    <span className="brand-name">河南云螭</span>
                                    <span className="brand-slogan">Yunchi Machinery</span>
                                </div>
                            </div>
                            <p className="brand-description">
                                {t('footer.description')}
                            </p>
                            <div className="social-links">
                                <a href="https://wa.me/8615716377150" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div className="footer-links">
                            <h4 className="footer-heading">{t('footer.products')}</h4>
                            <ul>
                                {[
                                    {key: "high-speed-disperser", content: t('footer.highSpeedDisperser'), href: "/products"},
                                    {key: "mixer-production-line", content: t('footer.mixerProductionLine'), href: "/products"},
                                    {key: "chili-shearing", content: t('footer.chiliShearing'), href: "/products"},
                                    {key: "wall-panel-installer", content: t('footer.wallPanelInstaller'), href: "/products"},
                                    {key: "portable-cutting-saw", content: t('footer.portableCuttingSaw'), href: "/products"},
                                    {key: "suction-cup-installer", content: t('footer.suctionCupInstaller'), href: "/products"},
                                ].map((item) => (
                                    <li key={item.key}>
                                        <a href={item.href}>{item.content}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-links">
                            <h4 className="footer-heading">{t('footer.company')}</h4>
                            <ul>
                                {[
                                    {key: "about", content: t('footer.aboutUs'), href: "/about"},
                                    {key: "products", content: t('footer.allProducts'), href: "/products"},
                                ].map((item) => (
                                    <li key={item.key}>
                                        <a href={item.href}>{item.content}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-contact">
                            <h4 className="footer-heading">{t('footer.contact')}</h4>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <span className="contact-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                                            <circle cx="12" cy="10" r="3"/>
                                        </svg>
                                    </span>
                                    <span className="contact-text">{t('footer.address')}</span>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                                        </svg>
                                    </span>
                                    <a href="tel:+8615716377150" className="contact-link">+86 15716377150</a>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                            <polyline points="22,6 12,13 2,6"/>
                                        </svg>
                                    </span>
                                    <a href="mailto:guohaolei@yunchijixie.com" className="contact-link">guohaolei@yunchijixie.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="footer-container">
                    <div className="footer-bottom-content">
                        <p className="copyright">&copy; {currentYear} Yunchi Machinery. {t('footer.rights')}</p>
                        <div className="footer-legal">
                            <a href="#">{t('footer.privacy')}</a>
                            <span className="divider">|</span>
                            <a href="#">{t('footer.terms')}</a>
                        </div>
                    </div>
                    <div className="footer-beian">
                        <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener noreferrer">
                            <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgMWgyMHYyMEgxVjF6bTE1IDFoMTB2MTBIMjZ2MTBIMjB2MTBIMFYxeiIgZmlsbD0iIzZCNkU2RSIgZmlsbC1ydW5pdGU9Im1peC1ib3VuZCBtdWx0aXBsZS1ydW5pdGUiLz48L3N2Zz4=" alt="公安备案"/>
                            <span>豫ICP备2024040763号-51</span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
